<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-user-alt"></i>
        Admin List
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">management</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Admin</a>
        </li>
      </ul>
    </div>
    <!-- detail_search -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_use" v-b-tooltip.hover>Join_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1MO</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1MO</b-button>
            <b-form inline class="mt-2 ml-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_visit">Login_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2" size="sm" variant="outline-primary" @click="set_sd('', 'last_visit')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d', 'last_visit')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w', 'last_visit')">-1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m', 'last_visit')">-1MO</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w', 'last_visit')">1WK</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m', 'last_visit')">1MO</b-button>
            <b-form inline class="mt-2 ml-2">
              <date-picker @change="refresh" v-model="so.opt.last_visit_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.last_visit_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label mb-4" for="opt_username_admin">Username</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_username_admin" v-model="so.opt['username']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="opt_username_admin">Nickname</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mb-3">
          <b-form-input @keydown.enter="refresh" type="text" id="opt_nickname_admin" v-model="so.opt['nickname']"></b-form-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mr-2">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail_search -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2"> Total : <span style="padding-left: 1.1rem"></span>{{model.total.toString().padStart(3, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_info mb-2"> Use :<span style="padding-left: 1.9rem"></span>{{model.enable.toString().padStart(3, nbsp) | number}}</span>
        <br>
        <span class="badge badge_border_warning mb-2"> Deleted : {{model.disable.toString().padStart(3, nbsp) | number}}</span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center"> 
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;"  @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option value="">Search</option>
              <option value="username">Username</option>
              <option value="nickname">Nickname</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1 mt-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- search detail button
            <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div>
          <div class="mb7 mr-2 mt-2">
            <button v-if="enable_new !== false" size="sm" type="button" class="btn btn-sm btn-addition" tabindex="4" @click="$router.push({ name: 'admin', params: { id : 'add' } })">
              New Registration
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | sdate }}</template>
            <template slot="status" slot-scope="row">
              <span v-if="row.item.is_del">
                <b-badge variant="danger">Deleted</b-badge>
              </span>
              <span v-else>
                <b-badge :variant="row.item.is_alive ? 'success' : 'secondary'">{{row.item.is_alive ? 'On' : 'Off'}}</b-badge>
              </span>
            </template>
            <template slot="username" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.username}}</del>
              <span v-else>{{row.item.username ? row.item.username : '-'}}</span>
            </template>
            <template slot="nickname" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.nickname}}</del>
              <span v-else>{{row.item.nickname ? row.item.nickname : '-'}}</span>
            </template>
            <template slot="last_visit" slot-scope="row">{{row.item.last_visit | sdate }}</template>
          </b-table>
        </div>
      </div>
    </div>
    <b-row class="mt30">
      <b-col class="pagination justify-content-center">
        <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
      </b-col>
    </b-row>
  </div>
  </template>
  
  <script>
  import App from './app.js'; export default Object.assign({}, App);
  </script>